import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="print:hidden"><Header /></div>
      <main className="flex-1">
        <Outlet />
      </main>
      <div className="print:hidden"><Footer /></div>
    </div>
  );
}
